import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { DraggableWindow } from '../DraggableWindow';
import { InputSelect } from '../../../.common/InputSelect/InputSelect';

import { LayoutContext } from '../../../../modules/ContextModules/LayoutContext';
import { LocateItem } from './LocateItem/LocateItem';
import './LocateTool.css'

import locate from './.image/locate-2.png';

export class LocateTool extends Component {
    static contextType = LayoutContext;
    constructor(props) {
        super(props);

        this.state = {
            isOpenFunc: false,
            funcName: "",
            地址: "",
            行政區List: [],
            行政區: "-1",
            行政區Id: "",
            地址: "",
            道路List: [],
            道路: "-1",
            號: "-1",
            之: "-1",
            sectionCode: "",
            landCode: "",
            lon: "",
            lat: "",
        }

        this.list = [
            {
                name: "座標定位",
            },
            {
                name: "門牌定位",
            },
            {
                name: "地號定位",
            },
        ]
    }

    componentDidMount() {
        let workerWaitForInit;
        function waitForInit() {
            if (!!window.gMainMap.IsReady) {
                clearInterval(workerWaitForInit);
                this.custom = this.GetCustomLayer();
            }
        }
        workerWaitForInit = setInterval(waitForInit.bind(this), 1000);

        this.get行政區List();
    }

    componentWillUnmount() {
        window.gMainMap.TerrainView.removeLayer(this.custom)
    }

    GetCustomLayer() {
        const CustDrawLayerID = "_SearchCoorLayer";
        let layer = window.gMainMap.TerrainView.findLayer(CustDrawLayerID);
        if (!layer) {
            layer = window.gMainMap.TerrainView.addCustomLayer(CustDrawLayerID);
            layer.setDepthTest(true);
        }

        return layer;
    }

    async get行政區List() {
        let url = "https://api.nlsc.gov.tw/other/ListTown/M"

        fetch(url)
            .then(response => response.text())
            .then(text => {
                let town = "";
                let townlist = [];
                let townId = {};
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(text, 'text/xml');
                for (let i = 0; ; i++) {
                    if (xmlDoc.getElementsByTagName("towncode")[i]) {
                        let townCode = xmlDoc.getElementsByTagName("towncode")[i].childNodes[0].nodeValue;
                        let townName = xmlDoc.getElementsByTagName("townname")[i].childNodes[0].nodeValue;
                        townlist.push(townName);
                        townId[townName] = townCode;
                    }
                    else { break; }
                }
                this.setState({ 行政區List: townlist, 行政區: "-1", 行政區Id: townId });
            })
            .catch(err => { console.log(err); });

    }

    async get道路List() {
        let url = `https://api.nlsc.gov.tw/idc/ListRoad/M/${this.state.行政區Id[this.state.行政區]}`

        fetch(url)
            .then(response => response.text())
            .then(text => {
                let name = "";
                let roadList = [];
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(text, 'text/xml');
                for (let i = 0; ; i++) {
                    if (xmlDoc.getElementsByTagName("name")[i]) {
                        let roadName = xmlDoc.getElementsByTagName("name")[i].childNodes[0].nodeValue;
                        roadList.push(roadName);
                        if (i == 0) {
                            name = roadName;
                        }
                    }
                    else { break; }
                }
                this.setState({ 道路List: roadList, 道路: "-1" });
            })
            .catch(err => { console.log(err); });
    }

    行政區onChange() {
        let text = "南投縣" + this.state.行政區;
        this.setState({ 地址: text })
        this.get道路List()
    }

    道路onChange() {
        let text = "南投縣" + this.state.行政區 + this.state.道路;
        this.setState({ 地址: text })
    }

    號onChange() {
        let text = "南投縣" + this.state.行政區 + this.state.道路 + this.state.號 + "號";
        this.setState({ 地址: text })
    }

    之onChange() {
        let text = "南投縣" + this.state.行政區 + this.state.道路 + this.state.號 + "號之" + this.state.之;
        this.setState({ 地址: text })
    }

    paintLocate(geoPoint) {
        this.custom.removeAllEntity();
        let param = {};
        param = {};
        geoPoint.z = 0
        param.geo = geoPoint;
        param.color = new window.ov.Color("#FF0000");
        param.opacity = 1.0;
        param.size = 50;
        param.epsg = 4326;
        param.absHeight = false;
        param.symbol = locate;
        this.custom.addPointEntity(param);
    }

    //座標定位
    goto() {
        let x = parseFloat(this.state.lon);
        let y = parseFloat(this.state.lat);

        if (x.toString() === "NaN" || y.toString() === "NaN") {
            window.alertify.log("請輸入正確數字。");
            return;
        }

        let geoPoint = new window.GeoPoint(x, y, 0);
        let v = new window.Geo3DPoint(0, 0, -1);
        let up = new window.Geo3DPoint(0, 1, 0);

        let camera = new window.ov.Camera(geoPoint, v, up);
        window.gMainMap.TerrainView.gotoCamera(camera, true);

        if (!this.custom) {
            return;
        }
        this.paintLocate(geoPoint)
    }

    //地號定位
    gotoCadas() {
        this.custom.removeAllEntity();
        if (this.state.sectionCode === "") {
            window.alertify.log("地段代碼不可為空。");
            return;
        }
        else if (this.state.landCode === "") {
            window.alertify.log("地號不可為空。");
            return;
        }

        let url = "https://api.nlsc.gov.tw/dmaps/CadasMapPosition/M/" + this.state.sectionCode + "/" + this.state.landCode
        fetch(url)
            .then(response => response.text())
            .then(text => {
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(text, 'text/xml');

                let x = parseFloat(xmlDoc.getElementsByTagName("repX")[0].childNodes[0].nodeValue);
                let y = parseFloat(xmlDoc.getElementsByTagName("repY")[0].childNodes[0].nodeValue);
                let ldx = parseFloat(xmlDoc.getElementsByTagName("ldX")[0].childNodes[0].nodeValue);
                let ldy = parseFloat(xmlDoc.getElementsByTagName("ldY")[0].childNodes[0].nodeValue);
                let rtx = parseFloat(xmlDoc.getElementsByTagName("rtX")[0].childNodes[0].nodeValue);
                let rty = parseFloat(xmlDoc.getElementsByTagName("rtY")[0].childNodes[0].nodeValue);
                let pos = new window.GeoPoint({ x: x, y: y });

                let param = {};
                param.geo = new window.GeoPolygonSet(
                    new window.GeoPolygon([new window.GeoPoint(ldx, rty), new window.GeoPoint(rtx, rty), new window.GeoPoint(rtx, ldy), new window.GeoPoint(ldx, ldy)]));
                param.color = "#FFFF00";
                param.opacity = 0.5;
                param.epsg = 4326;
                if (!this.custom) {
                    return;
                }
                this.custom.addSurfacePolygonSetEntity(param);
                window.gMainMap.TerrainView.goto(pos, 500, false);
            })
            .catch(err => { console.log(err); });
    }

    //門牌定位
    gotoDoorplate() {
        let 縣市代碼 = "M";//南投縣
        let url = `https://api.nlsc.gov.tw/idc/TextQueryAddress/${this.state.地址}/1/${縣市代碼}`
        fetch(url)
            .then(response => response.text())
            .then(text => {
                let contentList = [];
                let locationList = [];
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(text, 'text/xml');
                for (let i = 0; ; i++) {
                    if (xmlDoc.getElementsByTagName("content")[i]) {
                        let content = xmlDoc.getElementsByTagName("content")[i].childNodes[0].nodeValue;
                        let location = xmlDoc.getElementsByTagName("location")[i].childNodes[0].nodeValue;
                        contentList.push(content)
                        locationList.push(location)
                    }
                    else { break; }
                }
                if (locationList.length == 0) {
                    console.log("error:找不到")
                    return
                }
                let 座標 = locationList[0].split(',')
                let geoPoint = new window.GeoPoint(parseFloat(座標[0]), parseFloat(座標[1]), 0);
                let height = window.gMainMap.TerrainView.getAbsHeight(geoPoint, 4326)
                geoPoint.z = height + 200;
                let v = new window.Geo3DPoint(0, 0, -1);
                let up = new window.Geo3DPoint(0, 1, 0);
                let camera = new window.ov.Camera(geoPoint, v, up);
                window.gMainMap.TerrainView.gotoCamera(camera, true);
                if (!this.custom) {
                    return;
                }
                this.paintLocate(geoPoint);
            });
    }

    render() {
        // 在 render 中將可以使用 this.context
        return (
            <DraggableWindow
                header="定位工具"
                content={this.content()}
                width={this.props.width}
                height={this.props.height}
                defaultPosition={this.props.defaultPosition}
                handleMinimize={this.props.handleMinimize}
                handleCancel={this.props.handleCancel}
                isShow={this.props.isShow} />
        );
    }

    //座標查詢
    searchByCoordinate() {
        return (
            <div className="locateBox">
                <div className='locateTool-row' style={{ margin: 0, padding: 0, fontSize: "0.5em" }}>
                    <span>採用WGS84經緯度座標系</span>
                </div>
                <div className="locateTool-row">
                    <span>經度:</span>
                    <input type="text"
                        className='locateTool-text'
                        style={{ backgroundColor: "#f2dbdb" }}
                        value={this.state.lon}
                        onChange={(e) => { this.setState({ lon: e.target.value }) }}
                    />
                </div>
                <div className="locateTool-row">
                    <span>緯度:</span>
                    <input type="text"
                        className='locateTool-text'
                        style={{ backgroundColor: "#f2dbdb" }}
                        value={this.state.lat}
                        onChange={(e) => { this.setState({ lat: e.target.value }) }}
                    />
                </div>
                <div className='locateTool-row' style={{ alignItems: "flex-start", justifyContent: "space-between" }}>
                    <button className="locateTool-btn" onClick={() => { this.goto(); }}>定位</button>
                </div>
            </div>
        );
    }

    //地號查詢
    searchByCadasPanel() {
        return (
            <div className="locateBox">
                <div className='locateTool-row'>
                    <span>南投地號查詢</span>
                </div>
                <div className="locateTool-row">
                    <span>地段代碼:</span>
                    <input type="text"
                        className='locateTool-text'
                        style={{ backgroundColor: "#f2dbdb" }}
                        value={this.state.sectionCode}
                        onChange={(e) => { this.setState({ sectionCode: e.target.value }) }}
                    />
                </div>
                <div className="locateTool-row">
                    <span>地號:</span>
                    <input type="text"
                        className='locateTool-text'
                        style={{ backgroundColor: "#f2dbdb" }}
                        value={this.state.landCode}
                        onChange={(e) => { this.setState({ landCode: e.target.value }) }}
                    />
                </div>
                <div className='locateTool-row' style={{ alignItems: "flex-start", justifyContent: "space-between" }}>
                    <button className="locateTool-btn" onClick={() => { this.gotoCadas(); }}>定位</button>
                </div>
            </div>
        );
    }

    //門牌查詢
    searchByDoorplatePanel() {
        return (
            <div className="locateBox">
                <div className='locateTool-row' style={{ paddingTop: "2.685vh", marginRight: "1.365vw" }}>
                    <span>搜尋地址:</span>
                    <input type="text" value={this.state.地址} onChange={(e) => {
                        this.setState({ 地址: e.target.value });
                    }} disabled />
                </div>
                <div className='locateTool-row' style={{ paddingTop: "2.685vh", marginRight: "1.365vw" }}>
                    <span>行政區:</span>
                    <InputSelect Options={this.state.行政區List} OnChange={(e) => {
                        this.setState({ 行政區: e.target.value }, () => {
                            this.行政區onChange();
                        });
                    }}> </InputSelect>
                </div>
                <div className='locateTool-row' style={{ paddingTop: "1.944vh", marginRight: "1.365vw" }}>
                    <span>道路:</span>
                    <InputSelect Options={this.state.道路List} OnChange={(e) => {
                        this.setState({ 道路: e.target.value }, () => {
                            this.道路onChange();
                        });
                    }}></InputSelect>
                </div>
                <div className='locateTool-row' style={{ paddingTop: "1.944vh", marginRight: "1.365vw" }}>
                    <Input type="text"
                        style={{ marginLeft: "1.2vw", marginRight: "0.57vw" }}
                        onChange={(e) => {
                            this.setState({ 號: e.target.value }, () => {
                                this.號onChange();
                            })
                        }}></Input>
                    <span style={{
                        display: "flex",
                        justifyContent: "center",
                        marginRight: "0.57vw"
                    }}>號，之</span>
                    <Input type="text" onChange={(e) => {
                        this.setState({ 之: e.target.value }, () => {
                            this.之onChange();
                        })
                    }}></Input>
                </div>
                <div className='locateTool-row' style={{ alignItems: "flex-start", justifyContent: "space-between" }}>
                    <button className="locateTool-btn" onClick={() => { this.gotoDoorplate(); }}>定位</button>
                </div>
            </div>
        );
    }

    content() {
        return (
            <div className='locateTool'>
                <div className="locateItem-box">
                    {
                        this.list.map(item => {
                            if (this.state.isOpenFunc && item.name === this.state.funcName) {
                                return <LocateItem key={item.name} data={item} handleClick={this.handleClick} checked={true} />
                            }
                            return <LocateItem key={item.name} data={item} handleClick={this.handleClick} />
                        })
                    }
                </div>
                {
                    this.state.isOpenFunc ?
                        this.state.funcName === "座標定位" ?
                            this.searchByCoordinate() :
                            this.state.funcName === "地號定位" ?
                                this.searchByCadasPanel() :
                                this.state.funcName === "門牌定位" ?
                                    this.searchByDoorplatePanel() : null : null
                }
            </div>
        );
    }

    handleClick = (data) => {
        let isOpenFunc = this.state.isOpenFunc;
        if (this.state.funcName === data.name) {
            isOpenFunc = !isOpenFunc;
        }
        else {
            isOpenFunc = true;
        }
        switch (data.name) {
            case "座標定位": {
                this.setState({ isOpenFunc: isOpenFunc, funcName: "座標定位" });
            }
                break;
            case "門牌定位": {
                this.setState({ isOpenFunc: isOpenFunc, funcName: "門牌定位" });
            }
                break;
            case "地號定位": {
                this.setState({ isOpenFunc: isOpenFunc, funcName: "地號定位" });
            }
                break;
        }
    }
}